import { IHomeAPI } from "./homeSlice.types"
import requester from "api/requester"

const homeAPI: IHomeAPI = {
  getMeals(payload, signal) {
    return requester.get("/meals", { ...payload }, { signal })
  },

  getDailyProgress(date, signal) {
    return requester.get("/progresses/daily", { date }, { signal })
  },

  getMonthlyProgress(from, to, signal) {
    return requester.get(
      "/progresses/monthly",
      {
        from_date: from,
        to_date: to,
      },
      { signal },
    )
  },

  deleteMeal: (mealId) => requester.delete(`/meals/${mealId}`),
}

export default homeAPI
